function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.4994 0.665429C14.8061 0.444616 15.2327 0.444882 15.5391 0.666079L29.1674 10.5061C29.3771 10.6575 29.5 10.8917 29.5 11.14V28.66C29.5 29.6776 29.0705 30.654 28.305 31.3743C27.5395 32.0948 26.5005 32.5 25.4167 32.5H4.58334C3.49945 32.5 2.46053 32.0948 1.69498 31.3743C0.92952 30.654 0.5 29.6776 0.5 28.66V11.14C0.5 10.8914 0.623266 10.6568 0.833548 10.5054L14.4994 0.665429ZM11.329 30.9H18.7086V18.1H11.329V30.9ZM20.4145 30.9V17.3C20.4145 16.8582 20.0326 16.5 19.5616 16.5H10.4761C10.005 16.5 9.62311 16.8582 9.62311 17.3V30.9H4.58334C3.95372 30.9 3.34931 30.6646 2.90323 30.2449C2.45705 29.825 2.20588 29.2549 2.20588 28.66V11.5344L15.0181 2.30907L27.7941 11.5337V28.66C27.7941 29.2549 27.5429 29.825 27.0968 30.2449C26.6507 30.6646 26.0463 30.9 25.4167 30.9H20.4145Z",
  fill: "#383A35"
});

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.df74c3b6.svg";
export { ForwardRef as ReactComponent };